import PrescriberProfile from './PrescriberProfile'

export default PrescriberProfile
